import { render, staticRenderFns } from "./TitleDetailTitleClipsV1.vue?vue&type=template&id=51c77d9c"
import script from "./TitleDetailTitleClipsV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailTitleClipsV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailTitleClipsV1.vue?vue&type=style&index=0&id=51c77d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports